export const genericRequest = async (url) => {
  let data = null;
  try {

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 8000);

    const response = await fetch(url, {
      headers: {
        "Content-Type": "application/json"
      },
      method: "GET",
      signal: controller.signal,
    });

    clearTimeout(timeoutId);
    data = await response.json();
    if (!response.ok) {
      console.log("Error in response:", response);
      return null;
    }
  } catch (error) {
    console.log(error);
  }
  return data;
};

export const iterationPerDomain = async (domains, path) => {
  let data = null;
  let iteration = 0;
  do {
    const url = `${domains[iteration]}${path}`;
    data = await genericRequest(url);
    iteration++;
  } while (data === null && iteration < domains.length);

  return data || [];
}